import type { ExperimentConfig } from '../@types'

// Don't start before japanese_water_fasting.landing.* land in web.json — the variant renders raw keys.
const config: ExperimentConfig[] = [
	{
		'female-water-fasting': {
			// /water-fasting-f?safe&utm_source=FB&country=US&area=female-water-fasting&exp=web_female_water_fasting_japanese~1
			landing: {
				experiment: () =>
					import(
						/* webpackChunkName: "landing" */ '@/modules/Landing/instances/experiments/web_female_water_fasting_japanese'
					),
			},
		},
	},
]

export default config
